import { Instagram, Facebook } from "lucide-react";
import Logo from "@/components/Logo";
import TikTokIcon from "@/components/icons/TikTokIcon";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 px-6 lg:px-10 py-14"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
        <div>
          <a href="#top" className="inline-block mb-6">
            <Logo size="md" />
          </a>
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            Witbank's home for serious soccer development. Giving talent a
            platform — since 2022.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-red-600 mb-4">
              Explore
            </p>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a href="#about" className="hover:text-red-600">
                  About
                </a>
              </li>
              <li>
                <a href="#programs" className="hover:text-red-600">
                  Programs
                </a>
              </li>
              <li>
                <a href="#coaches" className="hover:text-red-600">
                  Coaches
                </a>
              </li>
              <li>
                <a href="#register" className="hover:text-red-600">
                  Register
                </a>
              </li>
              <li>
                <a
                  href="https://customer-assets.emergentagent.com/job_soccer-academy-43/artifacts/kd9evc8d_STARS%20OF%20MPUMALANGA%20_Certificate.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-certificate-link"
                  className="hover:text-red-600 inline-flex items-center gap-1"
                >
                  Certificate ↗
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-red-600 mb-4">
              Contact
            </p>
            <ul className="space-y-2 text-sm text-white/70">
              <li>Witbank, Mpumalanga</li>
              <li>
                <a
                  href="https://wa.me/27659044297"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-red-600"
                >
                  WhatsApp: +27 65 904 4297
                </a>
              </li>
              <li className="break-all">
                <a
                  href="mailto:randy@starsofmp.co.za"
                  className="hover:text-red-600"
                >
                  randy@starsofmp.co.za
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="md:text-right">
          <p className="text-[10px] uppercase tracking-[0.3em] text-red-600 mb-4">
            Follow
          </p>
          <div className="flex gap-3 md:justify-end">
            {[
              { Icon: Instagram, label: "Instagram", href: "#" },
              { Icon: Facebook, label: "Facebook", href: "#" },
              {
                Icon: TikTokIcon,
                label: "TikTok",
                href: "https://www.tiktok.com/@stars.of.mpumalan",
              },
            ].map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-red-600 hover:border-red-600/50 transition"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:justify-between text-xs uppercase tracking-widest text-white/40">
        <span>© {new Date().getFullYear()} Stars of Mpumalanga · Witbank</span>
        <span>Forged in Mpumalanga.</span>
      </div>
    </footer>
  );
}
